import { render } from "./EditYacht.vue?vue&type=template&id=f6003d58"
import script from "./EditYacht.vue?vue&type=script&lang=js"
export * from "./EditYacht.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\Logica Yachts\\Front\\Logica-Yachts\\Dashboard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__